/* eslint-disable unicorn/filename-case */
export const isClient = (() => typeof window !== 'undefined' || typeof document !== 'undefined')();
